import { initializeApp } from 'firebase/app';
import {
  getAuth,
  OAuthProvider,
  GoogleAuthProvider,
  setPersistence,
  browserLocalPersistence,
} from 'firebase/auth';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Debug logging for environment variables
// console.log('Firebase Environment Debug:');
// console.log('- VITE_FIREBASE_PROJECT_ID:', import.meta.env.VITE_FIREBASE_PROJECT_ID);
// console.log('- VITE_FIREBASE_AUTH_DOMAIN:', import.meta.env.VITE_FIREBASE_AUTH_DOMAIN);
// console.log('- All env variables:', Object.keys(import.meta.env));

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Debug logging
// console.log('Firebase Config:', {
//   ...firebaseConfig,
//   apiKey: firebaseConfig.apiKey ? '[REDACTED]' : undefined,
//   authDomain: firebaseConfig.authDomain,
//   projectId: firebaseConfig.projectId,
// });

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore with persistence
const db = getFirestore(app);
enableIndexedDbPersistence(db).catch((err) => {
  if (err.code === 'failed-precondition') {
    // Multiple tabs open, persistence can only be enabled in one tab at a time.
    console.warn('Multiple tabs open, persistence can only be enabled in one tab at a time.');
  } else if (err.code === 'unimplemented') {
    // The current browser doesn't support persistence
    console.warn('The current browser doesn\'t support persistence');
  }
});

export function getFirestoreDb() {
  return db;
}

// Debug logging for initialized app
// console.log('Firebase App Initialized:');
// console.log('- Project ID:', app.options.projectId);
// console.log('- Auth Domain:', app.options.authDomain);

// Initialize Firebase services
export const auth = getAuth(app);

// Set persistence to LOCAL (this survives browser restarts)
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error('Error setting auth persistence:', error);
});

// Initialize providers
export const googleProvider = new GoogleAuthProvider();
googleProvider.addScope('email');
googleProvider.addScope('profile');
googleProvider.addScope('openid');
// Set custom parameters for Google Auth
googleProvider.setCustomParameters({
  prompt: 'select_account',
  access_type: 'offline'
});

export const appleProvider = new OAuthProvider('apple.com');
appleProvider.addScope('email');
appleProvider.addScope('name');

export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');

export default app;
